import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-560000ef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item" }
const _hoisted_2 = { class: "add-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_input = _resolveComponent("oio-input")!
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_oio_form_item = _resolveComponent("oio-form-item")!
  const _component_oio_form = _resolveComponent("oio-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_oio_form, { data: _ctx.formDdata }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keys, (item, index) => {
          return (_openBlock(), _createBlock(_component_oio_form_item, {
            key: index,
            name: "k",
            label: "属性值",
            required: ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_oio_input, {
                  value: item.k,
                  "onUpdate:value": ($event: any) => ((item.k) = $event),
                  placeholder: "请输入属性值"
                }, null, 8, ["value", "onUpdate:value"]),
                (_ctx.keys.length > 1)
                  ? (_openBlock(), _createBlock(_component_oio_button, {
                      key: 0,
                      type: "link",
                      onClick: ($event: any) => (_ctx.onDel(index)),
                      style: {"margin-left":"20px","color":"#d9363e"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createVNode(_component_oio_button, {
            type: "link",
            onClick: _ctx.onAdd
          }, {
            default: _withCtx(() => [
              _createTextVNode(" + 添加")
            ]),
            _: 1
          }, 8, ["onClick"])
        ], 512), [
          [_vShow, _ctx.keys.length]
        ])
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}